import {loadMesProConfigApi} from "@/api/domainApi/domainComApi";
import defMesProConfigJson from './defMesProConfigJson';
import {StorageUtils} from "xmgoing-utils";

export function useMesProConfigHooks(){
  const mesProConfig=ref({});

  const loadMesProConfig=async()=>{
    loadMesProConfigApi({}).then((res)=>{
      if(res&&Object.keys(res).length>0){
        mesProConfig.value={...defMesProConfigJson,...res};
        StorageUtils.addSessionItem('mesProConfig',JSON.stringify(mesProConfig.value))
      }
    });
  }

  onMounted(()=>{
    loadMesProConfig();
  })
  return {
    mesProConfig
  }
}
